import * as ambassadorWixPremiumDomainsV2Availability from './premium-domains-v2-availability-domain-availability.http.js';
import * as ambassadorWixPremiumDomainsV2AvailabilityTypes from './premium-domains-v2-availability-domain-availability.types.js';
import * as ambassadorWixPremiumDomainsV2AvailabilityUniversalTypes from './premium-domains-v2-availability-domain-availability.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function checkDomainAvailability(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPremiumDomainsV2AvailabilityUniversalTypes.CheckDomainAvailabilityRequest,
  ambassadorWixPremiumDomainsV2AvailabilityTypes.CheckDomainAvailabilityRequest,
  ambassadorWixPremiumDomainsV2AvailabilityUniversalTypes.CheckDomainAvailabilityResponse,
  ambassadorWixPremiumDomainsV2AvailabilityTypes.CheckDomainAvailabilityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPremiumDomainsV2Availability.checkDomainAvailability(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/check-domain-availability',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DomainAvailability as DomainAvailabilityOriginal,
  PremiumType as PremiumTypeOriginal,
  PremiumTypeWithLiterals as PremiumTypeWithLiteralsOriginal,
  CheckDomainAvailabilityRequest as CheckDomainAvailabilityRequestOriginal,
  CheckDomainAvailabilityResponse as CheckDomainAvailabilityResponseOriginal,
} from './premium-domains-v2-availability-domain-availability.types.js';
